export default __webpack_public_path__ + "static/media/chevron-down-small.0b993e34.svg";